var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 7.1999C10.6741 7.1999 9.59961 6.12539 9.59961 4.7999C9.59961 3.47442 10.6741 2.3999 11.9996 2.3999C13.3251 2.3999 14.3996 3.47442 14.3996 4.7999C14.3996 6.12539 13.3251 7.1999 11.9996 7.1999Z",
    fill: "#68666C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 14.3999C10.6741 14.3999 9.59961 13.3254 9.59961 11.9999C9.59961 10.6744 10.6741 9.5999 11.9996 9.5999C13.3251 9.5999 14.3996 10.6744 14.3996 11.9999C14.3996 13.3254 13.3251 14.3999 11.9996 14.3999Z",
    fill: "#68666C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 21.5999C10.6741 21.5999 9.59961 20.5254 9.59961 19.1999C9.59961 17.8744 10.6741 16.7999 11.9996 16.7999C13.3251 16.7999 14.3996 17.8744 14.3996 19.1999C14.3996 20.5254 13.3251 21.5999 11.9996 21.5999Z",
    fill: "#68666C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDot);
export default __webpack_public_path__ + "static/media/icon-dot.688acfaab08fe91106cce36bb6917201.svg";
export { ForwardRef as ReactComponent };